module.exports = __webpack_public_path__ + "static/media/catering.2d523a31.svg";